import * as types from './constants';

export const getModulesConfiguration = () => ({
    types: [
        types.GET_MODULES_CONFIGURATION_REQUEST,
        types.GET_MODULES_CONFIGURATION_SUCCESS,
        types.GET_MODULES_CONFIGURATION_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/novaposhta/config`,
            method: 'GET',
        }),
});

export const updateModuleConfiguration = (config) => ({
    types: [
        types.UPDATE_MODULES_CONFIGURATION_REQUEST,
        types.UPDATE_MODULES_CONFIGURATION_SUCCESS,
        types.UPDATE_MODULES_CONFIGURATION_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/novaposhta/config`,
            method: 'POST',
            body: config
        }),
});

export const createTtn = (api_key, data, order_id) => ({
    types: [
        types.NOVAPOSHTA_TTN_CREATE_REQUEST,
        types.NOVAPOSHTA_TTN_CREATE_SUCCESS,
        types.NOVAPOSHTA_TTN_CREATE_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/novaposhta/order/create?api_key=` + api_key + '&order_id=' + order_id,
            method: 'POST',
            body: data
        }),
});

export const getDeliveryDate = (data) => ({
    types: [
        types.GET_DELIVERY_DATE_REQUEST,
        types.GET_DELIVERY_DATE_SUCCESS,
        types.GET_DELIVERY_DATE_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/novaposhta/order/calculate/date`,
            method: 'POST',
            body: data
        }),
});

export const getDeliveryCost = (data) => ({
    types: [
        types.GET_DELIVERY_COST_REQUEST,
        types.GET_DELIVERY_COST_SUCCESS,
        types.GET_DELIVERY_COST_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/novaposhta/order/calculate/cost`,
            method: 'POST',
            body: data
        }),
});

export const getMarkingPrintLink = (data) => ({
    types: [
        types.NOVAPOSHTA_MARKING_PRINT_LINK_REQUEST,
        types.NOVAPOSHTA_MARKING_PRINT_LINK_SUCCESS,
        types.NOVAPOSHTA_MARKING_PRINT_LINK_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/novaposhta/marking/link`,
            method: 'POST',
            body: data
        }),
});
